import React, { useState, useEffect } from "react";
import { Wheel } from "react-custom-roulette";
import "../../style/components/three/game/SpinWheelGame.scss";

const SpinWheelGame = (props) => {
  const [data, setData] = useState(props.data);
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [hasPlayed, setPlayed] = useState(false);
  const [rouletteData, setRouletteData] = useState(data);
  const [hasWonWheel, setHasWonWheel] = useState(false);
  const [spinningCompleted, setSpinningCompleted] = useState(false);
  const coupons = props.coupon.split(',');

  useEffect(() => {
    const addShortString = data.map((item) => ({
      completeOption: item.option,
      option:
        item.option.length >= 30
          ? item.option.substring(0, 30).trimEnd() + "..."
          : item.option,
    }));
    setRouletteData(addShortString);
  }, [data]);

  const handleSpinClick = () => {
    setPlayed(true);
    const newPrizeNumber = Math.floor(Math.random() * data.length);
    setPrizeNumber(newPrizeNumber);
    if (rouletteData[newPrizeNumber].completeOption !== "Try Again") {
      sessionStorage.setItem("wheelWon", "true");
      setHasWonWheel(true);
    } else {
      sessionStorage.setItem("wheelWon", "false");
      setHasWonWheel(false);
    }
    setMustSpin(true);
    setSpinningCompleted(false);
  };

  const resetGame = () => {
    setPlayed(false);
    sessionStorage.setItem("wheelWon", "false");
    setHasWonWheel(false);
    setSpinningCompleted(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText((rouletteData[prizeNumber].completeOption === ("Prize zone" || "Prize zone 1")) ? coupons[0].trim() : coupons[1].trim());
  };

  return (
    <>
      {spinningCompleted && hasWonWheel && (
        <div className="won" style={{ textAlign: "center" }}>
          <div className="want-to-pay-game-container spin-game">
            <h3>CONGRATULATIONS, YOU HAVE WON!</h3>
            <div className="navigation-instruction-wrapper">
              <p className="discount-code">
                Copy the discount code and use it at checkout
              </p>
            </div>
            <div className="code-container" style={{ marginBottom: "calc(10px + 1vw)" }}>
              <p>{(rouletteData[prizeNumber].completeOption === ("Prize zone" || "Prize zone 1")) ? coupons[0].trim() : coupons[1].trim()}</p>
              <div onClick={handleCopy} style={{cursor: 'pointer'}}>
                <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.9971 1.25H10.9411C9.10307 1.25 7.64707 1.25 6.50807 1.403C5.33607 1.561 4.38707 1.893 3.63807 2.641C2.89007 3.39 2.55807 4.339 2.40007 5.511C2.24707 6.651 2.24707 8.106 2.24707 9.944V16C2.24709 16.8934 2.56601 17.7575 3.14641 18.4367C3.72681 19.1159 4.53058 19.5657 5.41307 19.705C5.55007 20.469 5.81507 21.121 6.34507 21.652C6.94707 22.254 7.70507 22.512 8.60507 22.634C9.47207 22.75 10.5751 22.75 11.9421 22.75H15.0521C16.4191 22.75 17.5221 22.75 18.3891 22.634C19.2891 22.512 20.0471 22.254 20.6491 21.652C21.2511 21.05 21.5091 20.292 21.6311 19.392C21.7471 18.525 21.7471 17.422 21.7471 16.055V10.945C21.7471 9.578 21.7471 8.475 21.6311 7.608C21.5091 6.708 21.2511 5.95 20.6491 5.348C20.1181 4.818 19.4661 4.553 18.7021 4.416C18.5627 3.53351 18.113 2.72974 17.4338 2.14934C16.7546 1.56894 15.8905 1.25002 14.9971 1.25ZM17.1271 4.271C16.975 3.827 16.6879 3.44166 16.306 3.16892C15.924 2.89619 15.4664 2.74971 14.9971 2.75H10.9971C9.09007 2.75 7.73607 2.752 6.70707 2.89C5.70207 3.025 5.12207 3.279 4.69907 3.702C4.27607 4.125 4.02207 4.705 3.88707 5.711C3.74907 6.739 3.74707 8.093 3.74707 10V16C3.74678 16.4693 3.89326 16.927 4.166 17.3089C4.43873 17.6908 4.82407 17.9779 5.26807 18.13C5.24707 17.52 5.24707 16.83 5.24707 16.055V10.945C5.24707 9.578 5.24707 8.475 5.36407 7.608C5.48407 6.708 5.74407 5.95 6.34507 5.348C6.94707 4.746 7.70507 4.488 8.60507 4.367C9.47207 4.25 10.5751 4.25 11.9421 4.25H15.0521C15.8271 4.25 16.5171 4.25 17.1271 4.271ZM7.40507 6.41C7.68207 6.133 8.07007 5.953 8.80507 5.854C9.55907 5.753 10.5611 5.751 11.9961 5.751H14.9961C16.4311 5.751 17.4321 5.753 18.1881 5.854C18.9221 5.953 19.3101 6.134 19.5871 6.41C19.8641 6.687 20.0441 7.075 20.1431 7.81C20.2441 8.564 20.2461 9.566 20.2461 11.001V16.001C20.2461 17.436 20.2441 18.437 20.1431 19.193C20.0441 19.927 19.8631 20.315 19.5871 20.592C19.3101 20.869 18.9221 21.049 18.1871 21.148C17.4321 21.249 16.4311 21.251 14.9961 21.251H11.9961C10.5611 21.251 9.55907 21.249 8.80407 21.148C8.07007 21.049 7.68207 20.868 7.40507 20.592C7.12807 20.315 6.94807 19.927 6.84907 19.192C6.74807 18.437 6.74607 17.436 6.74607 16.001V11.001C6.74607 9.566 6.74807 8.564 6.84907 7.809C6.94807 7.075 7.12907 6.687 7.40507 6.41Z"
                        fill="white"
                      ></path>
                    </svg>
              </div>
            </div>
            {/* <div style={{ textAlign: "center" }}>
              <button onClick={resetGame}>Play Again</button>
            </div> */}
          </div>
        </div>
      )}
      {spinningCompleted && !hasWonWheel && (
        <div className="won" style={{ textAlign: "center" }}>
          <div className="want-to-pay-game-container spin-game">
            <h3>SORRY, YOU HAVE NOT WON THIS TIME.</h3>
            <p className="try-again">Try again in one hour.</p>
            {/* <div style={{ textAlign: "center" }}>
              <button onClick={resetGame}>Reset Quiz</button>
            </div> */}
          </div>
        </div>
      )}
      {!spinningCompleted &&  <div align="center" className="roulette-container">
        <h3>Spin the wheel and win a prize</h3>
        <div style={{overflow:"hidden"}}>
        <Wheel 
          mustStartSpinning={mustSpin}
          spinDuration={[0.2]}
          prizeNumber={prizeNumber}
          data={rouletteData}
          outerBorderColor={["#ccc"]}
          outerBorderWidth={[9]}
          innerBorderColor={["#f2f2f2"]}
          radiusLineColor={["tranparent"]}
          radiusLineWidth={[1]}
          textColors={["#f5f5f5"]}
          textDistance={55}
          fontSize={[16]}
          backgroundColors={[
            "#CA9532",
            "#EE3A24",
          ]}
          onStopSpinning={() => {
            setMustSpin(false);
            setSpinningCompleted(true);
          }}
        />
        </div>
        <button className="button roulette-button" onClick={handleSpinClick} style={{marginBottom: '10px'}}>
          Spin
        </button>
      </div> }
     
      {/* <br /> */}
    </>
  );
};

export default SpinWheelGame;